var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { Icon } from '../Icon/index';
const appearance = theme => color => {
    switch (color) {
        case 'primary': {
            return {
                normal: theme.palette.cyan.main,
                hover: theme.palette.cyan.dark,
            };
        }
        case 'secondary': {
            return {
                normal: theme.palette.neutral.main,
                hover: theme.palette.neutral.dark,
            };
        }
        case 'darker': {
            return {
                normal: theme.palette.neutral.dark,
                hover: theme.palette.neutral.darker,
            };
        }
        case 'positive': {
            return {
                normal: theme.palette.positive.main,
                hover: theme.palette.positive.light,
            };
        }
        case 'negative': {
            return {
                normal: theme.palette.negative.main,
                hover: theme.palette.negative.light,
            };
        }
        case 'download': {
            return {
                normal: theme.palette.cyan.main,
                hover: theme.palette.cyan.main,
            };
        }
        default: {
            return {
                normal: theme.palette.midnight.main,
                hover: theme.palette.neutral.darker,
            };
        }
    }
};
const LinkIcon = styled(Icon) `
  margin-right: 20px;
  cursor: pointer;
`;
const RightLinkIcon = styled(Icon) `
  margin-left: 5px;
  margin-top: -2px;
  cursor: pointer;
  vertical-align: middle;
`;
const DownloadWrapper = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const StyledLink = styled.a `
  ${({ theme, 'data-role': color, size, inverted, underline }) => `
    font-family: ${theme.typography.font.family.text};
    font-size: ${theme.typography.font.sizes[size]}px;
    font-weight: 600;
    font-style: normal;
    line-height: ${size === 'normal' ? 1.5 : 1.31};
    color: ${inverted ? theme.palette.white.main : appearance(theme)(color)['normal']};
    cursor: pointer;
    fill: ${inverted ? theme.palette.white.main : appearance(theme)(color)['normal']};
    ${underline ? 'text-decoration: underline' : 'text-decoration: none'};
    &:hover {
        color: ${inverted
    ? theme.palette.neutral.light
    : appearance(theme)(color)['hover']};
        fill: ${inverted
    ? theme.palette.neutral.light
    : appearance(theme)(color)['hover']};
    }
`};
`;
export class Link extends React.PureComponent {
    render() {
        const _a = this.props, { children, role, icon } = _a, props = __rest(_a, ["children", "role", "icon"]);
        let iconRender;
        switch (icon) {
            case 'internal':
                iconRender = (React.createElement(RightLinkIcon, { sprite: "icon-chevron_right", width: 16, height: 16 }));
                break;
            case 'external':
                iconRender = (React.createElement(RightLinkIcon, { sprite: "icon-external_link", width: 16, height: 16 }));
                break;
        }
        return role === 'download' ? (React.createElement(DownloadWrapper, null,
            React.createElement(LinkIcon, Object.assign({ sprite: "icon-download", width: 24, height: 24 }, props)),
            React.createElement(StyledLink, Object.assign({ "data-role": role }, props),
                children,
                iconRender))) : (React.createElement(StyledLink, Object.assign({ "data-role": role }, props),
            children,
            iconRender));
    }
}
Link.defaultProps = {
    size: 'normal',
    underline: false,
    inverted: false,
};
//# sourceMappingURL=Link.js.map